import { playerCountAtom } from "@/hooks/playerlist";
import { useAtomValue } from "jotai";
import { UsersIcon } from "lucide-react";


export default function PlayerlistSummary() {
    const playerCount = useAtomValue(playerCountAtom);
    const playerCountFormatted = playerCount.toLocaleString('de-DE');

    return (
        <div className="fc-rail-summary">
            <div className="fc-rail-summary-icon">
                <UsersIcon strokeWidth={1.5} />
            </div>
            <div className="fc-rail-summary-copy">
                <strong>{playerCountFormatted}</strong>
                <small>Online-Spieler</small>
            </div>
        </div>
    );
}
